import { Controller } from "@hotwired/stimulus"

// Collapsed out-of-stock settings for a single variant: a summary line that
// expands into the fields, with lead time and the custom texts revealed only by
// the behavior they belong to. Fields stay enabled while hidden — the model
// drops blanks, so nothing stale is written.
export default class extends Controller {
  static targets = ["panel", "summary", "select", "leadTime", "custom", "chevron"]

  toggle() {
    const open = this.panelTarget.classList.toggle("hidden") === false
    this.chevronTarget.classList.toggle("rotate-180", open)
  }

  refresh() {
    const behavior = this.selectTarget.value
    const option = this.selectTarget.selectedOptions[0]

    this.summaryTarget.textContent = option ? option.textContent.trim() : behavior
    this.leadTimeTarget.classList.toggle("hidden", behavior !== "backorder_with_lead_time")
    this.customTarget.classList.toggle("hidden", behavior !== "custom")
  }
}
